import React from 'react'
import Hero from '../components/Hero'
import Links from '../components/Links'
import About from '../components/About'
import Slider from '../components/Slider'
import DoraAgaint from '../components/DoraAgaint'
import Toknomic from '../components/Toknomic'
import Roadmap from '../components/Roadmap'
import Join from '../components/Join'

export default function Home() {
  return (
    <>

      <Hero />
      <Links />
      <About />
      <Slider />
      <DoraAgaint />
      <Toknomic />
      <Roadmap />
      <Join />
    </>
  )
}
